"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autocomplete = void 0;
var api_1 = require("../../api");
var autocomplete = function (input) {
    return (0, api_1.apiGet)({
        // endpoint: `v2/google/autocomplete?input=${input}`,
        endpoint: "v3/google/autocomplete?input=".concat(input),
    });
};
exports.autocomplete = autocomplete;
